import { mix } from "@chorda/core";
export const Link = (props) => {
    return mix({
        tag: 'a',
        reactions: {
            text: (v) => ({ text: v }),
            link: (v) => ({ dom: { href: v } })
        }
    }, props && {
        dom: {
            href: props.link,
            target: props.target,
        },
        text: props.text,
        injections: {
            text: props.text$,
            link: props.link$
        }
    });
};
